/**
 * 1stdibs
 * User: James
 * Date: 1/17/14
 */
"use strict";

var SoaModel = require('bunsen/models/SoaModel');
var SoaCollection = require('bunsen/collections/SoaCollection');
var _ = require('underscore');
var Backbone = require('dibs-backbone');

/**
 * @class DimensionSet
 * @extends SoaModel
 */
var DimensionSet = module.exports = SoaModel.extend();

/**
 * @class Shape
 * @extends SoaModel
 */
var Shape = SoaModel.extend({
    relations: [{
        key: 'validDimensions',
        collectionType: SoaCollection,
        type: Backbone.Many
    }]
});
/**
 * @class Shapes
 * @extends Shape
 */
var Shapes = SoaCollection.extend({
    model: Shape
});

_.extend(DimensionSet.prototype, /** @lends DimensionSet.prototype */{
    relations: [{
        key: 'validShapes',
        collectionType: Shapes,
        type: Backbone.Many
    }]
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/inventory/DimensionSet.js
// module id = 2044
// module chunks = 62